import { render, staticRenderFns } from "./AttendanceRequestContextMenu.vue?vue&type=template&id=6810d24f&scoped=true"
import script from "./AttendanceRequestContextMenu.vue?vue&type=script&lang=js"
export * from "./AttendanceRequestContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6810d24f",
  null
  
)

export default component.exports